import {
    Explore2Art4,
    Explore2Art5,
    Explore2Art6,
    Explore2Art9,

    Explore2Team3,
    Explore2Team2,
    Explore2Team4,

    Explore2Authors5

} from '../../utils/allImgs'

export const data1 = [
  {
    path1:'/',
    path2:'/',
    path3:'/',
    img1:Explore2Art9,
    img2:Explore2Team3,
    text1:'3 of 5 In Stock',
    text2:'#04 Jimi Hendrix',
    text3:'From colors, cards, typography to complex elements, you will find the who take the opportunity first.',
    price:0.239,
  },

  {
    path1:'/',
    path2:'/',
    path3:'/',
    img1:Explore2Art5,
    img2:Explore2Team2,
    text1:"SHE | Orange #1",
    text2:"1 Of 1 In Stock",
    text3:'From colors, cards, typography to complex elements, you will find the who take the opportunity first.',
    price:0.239,
  },

  {
    path1:'/',
    path2:'/',
    path3:'/',
    img1:Explore2Art6,
    img2:Explore2Team4,
    text1:"SHE | Orange #1",
    text2:"1 Of 1 In Stock",
    text3:'From colors, cards, typography to complex elements, you will find the who take the opportunity first.',
    price:0.239,
  },
  {
    path1:'/',
    path2:'/',
    path3:'/',
    img1:Explore2Art4,
    img2:Explore2Team3,
    text1:"3 of 5 In Stock",
    text2:"Building the World",
    text3:'From colors, cards, typography to complex elements, you will find the who take the opportunity first.',
    price:0.239,
  },

]

export const data2 = [
      {
        path1:'/',
        NumImg:1,
        img:Explore2Team2,
        path2:'/',
        text1:'Sophie B.',
        path3:'/',
        text2:'@SophieBolt',
        price:45.634,
      },
      {         
        path1:'/',
        NumImg:2,
        img:Explore2Team3,
        path2:'/',
        text1:'Anne Marie',
        path3:'/',
        text2:'@Anne_Marie12',
        price:42.124,
      },

      {         
        path1:'/',
        NumImg:3,
        img:Explore2Authors5,
        path2:'/',
        text1:'Ivanna',
        path3:'/',
        text2:'@Ivanna_lio',
        price:41.904,
      },

      {         
        path1:'/',
        NumImg:4,
        img:Explore2Team4,
        path2:'/',
        text1:'Peterson',
        path3:'/',
        text2:'@Peterson_278',
        price:39.261,
      },
      {         
        path1:'/',
        NumImg:3,
        img:Explore2Authors5,
        path2:'/',
        text1:'Ivanna',
        path3:'/',
        text2:'@Ivanna_lio',
        price:41.904,
      },

      {         
        path1:'/',
        NumImg:4,
        img:Explore2Team4,
        path2:'/',
        text1:'Peterson',
        path3:'/',
        text2:'@Peterson_278',
        price:39.261,
      }

]

export const data3 = [{text:'Newest Items' , checked:true},{text:'Added This Week' , checked:false},{text:'Added This Month' , checked:true}]

export const data4 = [{text:'Crypto Assets' , checked:false},{text:'Collectable Items' , checked:true},{text:'Gift Cards' , checked:false}]
